import { useState } from 'react';
import ControlProps from '../../../models/props';
import classes from './date-time-picker.module.css';

export interface DateTimePickerProps extends ControlProps {
	type: DateType,
	onValueChanged?: (date: Date) => void
	useNativeInterface?: boolean
}

export type DateType = "date" | "datetime" | "time"

function DateTimePicker(props: DateTimePickerProps) {
	const [currentDate, setCurrentDate] = useState(new Date());

	return (
		<div className='form-group'>
			<label htmlFor={props.id} className='control-label'>{props.text}</label>
			<input type={props.type} name={props.id} id={props.id} className='form-control'
				onChange={(e) => {
					const dateValue = new Date(e.currentTarget.value);
					// setCurrentDate(dateValue);
					props.onValueChanged?.(dateValue);
				}}
			/>
		</div>
	);
}

export default DateTimePicker;